import { render } from "./findPassword.vue?vue&type=template&id=881481b2&scoped=true"
import script from "./findPassword.vue?vue&type=script&lang=js"
export * from "./findPassword.vue?vue&type=script&lang=js"

import "./findPassword.vue?vue&type=style&index=0&id=881481b2&lang=scss&scoped=true"
import "./findPassword.vue?vue&type=style&index=1&id=881481b2&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-881481b2"]])

export default __exports__